import router from '@/router';

const OCRoutes = [
  {
    path: 'user/locks',
    name: 'UserLock',
    component: {
      name: 'UserLock',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'lock',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserLockIndex',
        component: () => import('../views/UserLockIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ]
  },
  {
    path: 'admin/locks',
    name: 'AdminLock',
    component: {
      name: 'AdminLock',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'lock',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminLockIndex',
        component: () => import('../views/LockIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminLockNew',
        component: () => import('../views/LockInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminLockIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminLockShow',
        component: () => import('../views/LockShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminLockIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminLockDetails',
            component: () => import('../views/LockDetails.vue'),
            meta: {
              backRoute: { name: 'AdminLockIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminLockEdit',
            component: () => import('../views/LockInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminLockDetails' },
            },
          },
          {
            path: 'lock_rights',
            name: 'AdminLockLockRights',
            component: {
              name: 'AdminLockRight',
              render(h) {
                return h('router-view');
              },
            },
            meta: {
              resource: 'lock_right',
            },
            get redirect() {
              return this.children[0];
            },
            children: [
              {
                path: '',
                name: 'AdminLockRightIndex',
                component: () => import('../views/lockRight/LockLockRights.vue'),
                meta: {
                  backRoute: { name: 'AdminLockIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminLockRightNew',
                component: () => import('../views/lockRight/LockRightInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminLockShow' },
                },
              },
              {
                path: ':lockRightId(\\d+)',
                name: 'AdminLockRightShow',
                component: () => import('../views/lockRight/LockRightShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminLockRightIndex',
                  },
                  tArgs: route => ({ name: route?.params?.id }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminLockRightDetails',
                    component: () => import('../views/lockRight/LockRightDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminLockRightIndex' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminLockRightEdit',
                    component: () => import('../views/lockRight/LockRightInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminLockRightDetails' },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));